export default __webpack_public_path__ + "static/media/pc02-1.51fafcf7.png";